import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import App from './App';
import { store } from './store';
import { buildTheme } from './theme';
import { useAppSelector } from './store/hooks';

const ThemedApp: React.FC = () => {
  const themeMode = useAppSelector((state) => state.theme.mode);
  const selectedThemeId = useAppSelector((state) => state.theme.selectedThemeId);
  const activeTheme = buildTheme(themeMode, selectedThemeId);
  return (
    <ThemeProvider theme={activeTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemedApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
